export class ConfirmStatusChangeItemModel {
  count: number;
  from: string;
  to: string;
}
